module.exports = __webpack_public_path__ + "img/Group16.7beef099.png";